
import { createSlice } from "@reduxjs/toolkit";
import { getPanel } from "../reduxApi/panelReduxAPi";

const panelSlice = createSlice({
    name: 'panel',
    initialState: {
        status: 'idel',
        panel: [],
    },
    reducers: {
        deletePanelAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.panel.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.panel.splice(index, 1);
                }
            });
        },
        updatePanelAction: (state, action) => {
            // console.log("action", action.payload.ROWID)
            const index = state.panel.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.panel.splice(index, 1, action.payload)
    
            }
        },
        addPanelAction: (state, action) => {
            const temp = action.payload.formData;
            console.log("temp",temp);
            
            temp.ROWID = action.payload?.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.panel.unshift(temp);           
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPanel.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getPanel.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.panel = action.payload.data.panels;
            })
    }
})
export const { deletePanelAction, updatePanelAction, addPanelAction } = panelSlice.actions
export default panelSlice.reducer